var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#0F6CBD",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0443 2.65775C9.98187 2.59478 9.89694 2.55928 9.80829 2.55908C9.71973 2.5591 9.63481 2.59436 9.57229 2.65708L2.29095 9.94042C2.16083 10.0706 2.16083 10.2816 2.29095 10.4117L5.58962 13.7104C5.71979 13.8405 5.93079 13.8405 6.06095 13.7104L13.339 6.43242C13.4686 6.30233 13.4686 6.09184 13.339 5.96175L10.0443 2.65775Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.62001 11.2004C1.53464 11.1153 1.40999 11.0829 1.29401 11.1157C1.17784 11.1483 1.08834 11.2411 1.06001 11.3584L0.0560088 15.5431C0.0290657 15.6558 0.0626432 15.7745 0.144675 15.8564C0.227193 15.9374 0.345388 15.9706 0.458009 15.9444L4.63934 14.9444C4.75675 14.9163 4.84979 14.8269 4.88257 14.7107C4.91535 14.5945 4.88275 14.4697 4.79734 14.3844L1.62001 11.2004Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4672 1.94973L14.0519 0.533731C13.4013 -0.115573 12.3478 -0.115573 11.6972 0.533731L10.7519 1.4784C10.6218 1.60856 10.6218 1.81956 10.7519 1.94973L14.0519 5.24906C14.1821 5.37919 14.3931 5.37919 14.5232 5.24906L15.4672 4.30306C16.1156 3.65262 16.1156 2.60018 15.4672 1.94973Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenIcon);
export default __webpack_public_path__ + "static/media/pen-icon.9b3f097de44baa804111ec62d384e323.svg";
export { ForwardRef as ReactComponent };